module.exports = function () {
    $(document).ready(function () {

        iirRooms();

        var helper = require('./helper');

        function iirRooms(){

            var $roomsField = $('.js-iir-rooms');

            $roomsField.on('change', function(){

                var $this = $(this),
                    $roomsNumber = parseInt($this.val()),
                    $content,
                    fieldStart,
                    field,
                    fieldEnd,
                    rooms = [],
                    $roomsWrapper = $(document.querySelector('.js-iir-rooms-forms'));

                if(isInt($roomsNumber)){

                    for(var i=0;i<$roomsNumber;i++){
                        var oldFieldValue = $roomsWrapper.find('[name="rooms['+i+']"]').val(); // :checked
                        rooms[i] = oldFieldValue;
                    }

                    //console.log(rooms);
                    //console.log($roomsNumber);

                    $roomsWrapper.html('');

                    for(var i=0;i<$roomsNumber;i++){

                        $content = $roomsWrapper.html();

                        fieldStart = '<div class="col-xs-3"><div class="form-group ">' +
                        '<label for="rooms['+i+']" class="control-label col-sm-4 label-required iir-smaller-text">Room '+(i+1)+'</label>' +
                        '<div class="col-sm-8"> ' +
                        '<select class="form-control" id="rooms['+i+']" name="rooms['+i+']">';

                        field = '';

                        if(rooms[i] == 0){ field += '<option value="0" selected="selected">Single</option>'; } else{ field += '<option value="0">Single</option>' }
                        if(rooms[i] == 1){ field += '<option value="1" selected="selected">Double</option>'; } else{ field += '<option value="1">Double</option>' }
                        if(rooms[i] == 2){ field += '<option value="2" selected="selected">Large</option>'; } else{ field += '<option value="2">Large</option>' }
                        if(rooms[i] == 3){ field += '<option value="3" selected="selected">Very Large</option>'; } else{ field += '<option value="3">Very Large</option>' }
                        if(rooms[i] == 4){ field += '<option value="4" selected="selected">Unit</option>'; } else{ field += '<option value="4">Unit</option>' }
                        if(rooms[i] == 5){ field += '<option value="5" selected="selected">Flat</option>'; } else{ field += '<option value="5">Flat</option>' }

                        fieldEnd =
                        '</div>' +
                        '</div></div>';

                        $roomsWrapper.html($content + fieldStart + field + fieldEnd);

                    }

                } else{
                    console.log('It is not a number!');
                }

            })
        }

            // Short-circuiting, and saving a parse operation
            function isInt(value) {
                var x;
                if (isNaN(value)) {
                    return false;
                }
                x = parseFloat(value);
                return (x | 0) === x;
            }

    });
}();